import { getDom, stopPropagation, mobile_deleteIconClick, setDeleteIconSrc } from './utils/function';

export function initInput(input) {
    const { inputElement, defaultContent } = input;
    this.input_el = getDom(inputElement);
    if (!this.input_el) return;

    // 处理元素属性
    this.input_el.setAttribute('contenteditable', true);
    this.input_el.setAttribute('placeholder', input.placeholder || '');
    if (this.options.mode === 'mobile') {
        this.input_el.classList.add('rhemoji-input-box-mobile');
    } else {
        this.input_el.classList.add('rhemoji-input-box');
    }

    this.input_el.style.outline = 'none';

    // this.input_el.addEventListener('onchange', ()=>{
    //     debugger
    // })

    // 绑定事件
    // this.input_el.addEventListener('click', resetRange);

    // const _that = this;
    // document.addEventListener('keyup', e => {
    //     if (_that.input_el.id === document.activeElement.id) {
    //         resetRange();
    //     }
    // });

    // 处理默认内容
    if (defaultContent) {
        const content = this.transCode2Img(defaultContent);

        this.input_el.innerHTML = content;
    }
}

export function initList(list) {
    const { iconElement, wrapElement, alignment } = list;
    this.list_el = getDom(wrapElement);
    this.icon_el = getDom(iconElement);

    // 处理icon
    const deleteIcon = document.createElement('img');
    // 处理list
    this.list_el.style.width = list.width ? list.width + 'px' : document.body.offsetWidth + 'px';
    this.list_el.style.height = list.height ? list.height + 'px' : '210px';
    this.list_el.style.display = list.defaultShow ? '' : 'none';

    const node = document.createElement('div');
    node.className = this.list_class + '-mobile';

    const listNode = document.createElement('div');
    listNode.className = this.list_class + '-content';

    const listUlNode = document.createElement('div');
    listUlNode.className = this.list_class + '-ul';

    this.emojis.forEach(i => {
        const para = document.createElement('img');
        para.setAttribute('class', 'emoji');
        para.setAttribute('src', i.src);
        para.onclick = e => this.handleImgClick(e, i, list, node, deleteIcon);
        listUlNode.appendChild(para);
    });

    const triangleNode = document.createElement('div');
    triangleNode.className = 'rhemoji-triangle-icon-mobile';
    handleTrianglePosition(this.icon_el, triangleNode, alignment);

    const deleteWrap = document.createElement('img');
    deleteWrap.src = 'https://upload.9fzt.com/production/frontend/archive/rhemoji/images/rhemoji-delete-wrap.png';
    deleteWrap.className = 'rhemoji-delete-wrap';

    deleteIcon.className = 'rhemoji-delete-icon';
    const content = this.getContent();

    setDeleteIconSrc(content, deleteIcon);
    this.deleteIcon = deleteIcon;

    deleteIcon.addEventListener('click', mobile_deleteIconClick.bind(this));

    ['keyup'].forEach(i => {
        this.input_el.addEventListener(i, () => {
            setDeleteIconSrc(this.getContent(), deleteIcon);
            this.onContentChange(this.getContent());
        });
    });

    listNode.appendChild(listUlNode);
    node.appendChild(triangleNode);
    node.appendChild(deleteIcon);
    node.appendChild(deleteWrap);
    node.appendChild(listNode);
    this.list_el.appendChild(node);

    // 处理事件
    this.icon_el.addEventListener('click', () => {
        if (!this.canToggle) return;
        if (this.list_el.style.display === 'none') {
            this.list_el.style.display = '';
        } else {
            this.list_el.style.display = 'none';
        }

        this.toggleChange && this.toggleChange();
    });

    // document.body.addEventListener('click', e => {
    //     if (e.target.id && e.target.id.indexOf(this.icon_el)) return;
    //     console.log('id', e.target.id);
    //     console.log('class', e.target.className);
    //     if (!e.target.class || e.target.class.indexOf('rhemoji-list-mobile') < 0) {
    //         node.style.display = 'none';
    //     }
    // });
}

export function handleImgClick(e, i, list, parentNode) {
    stopPropagation(e);
    this.input_el.focus();
    const selection = window.getSelection();

    const insertHtml = `<img draggable="false" class="rhemoji-emo-mobile" src="${i.src}" data-type="${i.code}">`;

    if (this.lastEditRange) {
        selection.removeAllRanges();
        selection.addRange(this.lastEditRange);
    }

    document.execCommand('insertHtml', false, insertHtml);

    // 添加表情后修改删除按钮状态
    setDeleteIconSrc(this.getContent(), this.deleteIcon);
    // 触发全局的onchange
    this.onContentChange(this.getContent());

    this.input_el.blur();

    if (list.autoClose) {
        parentNode.style.display = 'none';
    }
}

function handleTrianglePosition(el, node, alignment = ['left', 'top']) {
    node.style.position = 'absolute';

    const [tra, pro] = alignment;
    const trNodeWidth = 8;
    if (tra === 'left') {
        node.style.left = el.offsetLeft + el.offsetWidth / 2 - trNodeWidth + 'px';
    } else {
        node.style.right = document.body.offsetWidth - el.offsetLeft - el.offsetWidth / 2 - trNodeWidth + 'px';
    }

    node.style.top = -16 + 'px';
}
